<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="details_wrap container">
      <titleConfig :title="langSet == 'cn' ? '历届回顾详情' : 'Previous Exhibitions Details'" :type="2"></titleConfig>
      <div
        class="content"
        v-html="langSet == 'cn' ? details.content : details.en_content"
      ></div>
      <nodata v-if="langSet != 'cn' && !details.en_content"></nodata>
    </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "@/components/top.vue";
import bottom from "@/components/bottom.vue";
import titleConfig from "@/components/title.vue";
import nodata from "@/components/nodata.vue";
import { reviewDetail } from "@/api/api";
export default {
  // 配置title和meta数据
  metaInfo() {
    return {
      title: "历届回顾详情",
    };
  },
  components: {
    top,
    bottom,
    titleConfig,
    nodata
  },
  data() {
    return {
      langSet: "",
      id: "",
      details: {},
    };
  },
  created() {},
  mounted() {
    this.langSet = this.$language;
    this.id = this.$route.query.id;
    //25.9.16 获取新闻资讯 dxm
    this.getDetails(this.id);
  },
  methods: {
    async getDetails(id) {
      let data = {
        id,
      };
      const res = await reviewDetail(data);
      this.details = res.data;
    },
    currentChange(e) {
      this.pageNo = e;
      this.getList();
    },
    sizeChange(e) {
      this.pageSize = e;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
.details_wrap {
  padding-top: 80px;
  min-height: 500px;
  /deep/ p img{
    display: inline-block;
    max-width: 100%;
    height: auto !important;
  }
  /deep/ p video{
    max-width: 100%;
    height: auto !important;
  }
  .content {
    padding: 30px 30px 100px;
  }
}
@media only screen and (max-width: 767px) {
  .details_wrap {
    padding-top: 0.58rem;
    .content {
      padding: 0.3rem 0.3rem 1rem;
    }
  }
}
</style>